module.exports = __webpack_public_path__ + "img/comment_title.3d1f21e2.png";